import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {CommonModule, NgFor, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LoaderComponent} from "../../loader/loader.component";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {TabularDataDownloadService} from "../../../../services/tabular-data-download/tabular-data-download.service";
import {retailerData} from "../compare-dialog/compareDialogInterfaces";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTooltipModule} from "@angular/material/tooltip";
import { ToolboxModule } from 'src/app/shared/toolbox/toolbox.module';
import {RxAuthService} from "../../../../services/rx-auth/rx-auth.service";


@Component({
  selector: 'app-tabular-data-download-dialog',
  standalone: true,
  imports: [CommonModule, NgFor, FormsModule, NgIf, LoaderComponent, MatProgressSpinnerModule, MatTooltipModule, ToolboxModule],
  templateUrl: './tabular-data-download-dialog.component.html',
  styleUrls: ['./tabular-data-download-dialog.component.scss']
})
export class TabularDataDownloadDialogComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public auth: RxAuthService,
    private router: Router, private tabularDataDownloadService: TabularDataDownloadService,
  ) {
  }

  @Input() outputFileType: string | null = null;
  @Input() contentType: string | null = null;
  @Input() data: any | null = null;
  @Input() externalIds: any | null = null;
  @Input() externalRunTypeData: any = null;
  @Input() toggleState: boolean | null = null;
  @Input() currentProfile: any = null;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() toggleStateChange = new EventEmitter<{ value: boolean }>();

  loadingState = {value: true};
  availableEchelons: any[] = [];
  rclIDs: any[] = [];
  selectedEchelons: any[] = [];
  preselectedEchelons: any[] = [
    {
      name: 'Company profile(s)',
      includeForContentType: ['all'],
    },
    {
      name: 'Client(s)',
      includeForContentType: ['single-supplier', 'multi-supplier'],
    },
    {
      name: 'Product(s)',
      includeForContentType: ['single-supplier', 'multi-supplier'],
    },
  ]

  ngOnInit() {
    if (this.contentType !== null && this.externalRunTypeData === null) {
      (async () => {
        try {
          await this.tabularDataDownloadService.updateAvailableEchelons(this.rclIDs,
            this.availableEchelons,
            this.data,
            this.contentType as string
          );
          this.selectedEchelons = structuredClone(this.availableEchelons);
          this.mockToggleSelectedEchelons(this.selectedEchelons)

          this.rclIDs = this.data.rcl_id;
        } catch (error) {
          console.error('Failed to load echelons', error);
          this.loadingState.value = false;
        } finally {
          this.loadingState.value = false;
        }
      })();
    } else {
      this.rclIDs = this.externalIds;
      this.availableEchelons = this.externalRunTypeData;
      this.mockToggleSelectedEchelons(this.availableEchelons)
      this.loadingState.value = false;
    }
  }

  mockToggleSelectedEchelons(selected: any[]): void {
    selected.forEach(e => {
      const match = this.availableEchelons.find(a => a.id === e.id);
      if (match) {
        this.onEchelonSelectionToggle(match, { target: { checked: true } } as any);
      }
    });
  }

  isEchelonSelected(echelon: any): boolean {
    return this.selectedEchelons.some(selected => selected.id === echelon.id);
  }

  emitCloseDialog() {
    this.resetToggleState();
    this.closeDialog.emit();
  }

  onEchelonSelectionToggle(echelon: any, event: any) {
    if (event.target.checked) {
      this.selectedEchelons.push(echelon);
    } else {
      this.selectedEchelons = this.selectedEchelons.filter((e: any) => e !== echelon);
    }
  }

  downloadData() {
    this.toggleState = true;
    let filename = ''
    if (this.currentProfile?.retailer) {
      filename = this.currentProfile.retailer.name

    } else if (this.currentProfile?.current_list) {
      filename = this.currentProfile.current_list.name

    } else {
      filename = `${new Date().toLocaleDateString()} RetailX Intelligence data`
    }

    const payload = this.tabularDataDownloadService.createPayload(this.rclIDs, this.selectedEchelons, this.contentType as string, filename)

    const onDownloadComplete = () => {
      this.emitCloseDialog();
      this.resetToggleState();
    };

    this.tabularDataDownloadService.choseDownloadType(payload, this.contentType as string, this.outputFileType, onDownloadComplete)

  }

  resetToggleState() {
    this.toggleStateChange.emit({value: false});
  }
}
